var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthrTvWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.836,
    height: 22.835,
    viewBox: "0 0 22.836 22.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play-circle",
    "data-name": "Icon ionic-ios-play-circle",
    d: "M-628.265,353.116a11.418,11.418,0,0,0-11.419,11.417,11.419,11.419,0,0,0,11.417,11.419,11.417,11.417,0,0,0,11.419-11.417h0a11.416,11.416,0,0,0-11.414-11.418Zm3.965,12.159-6.168,3.814s-1.042.511-1.1-.713v-7.2c0-.194-.169-1.273.962-1.057l6.3,3.858C-623.733,364.376-624.142,365.181-624.3,365.275Z",
    transform: "translate(639.684 -353.116)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthrTvWhiteIcon);
export default __webpack_public_path__ + "static/media/othrTVWhiteIcon.d0f6f43bc09e387f4330f5ce145429c3.svg";
export { ForwardRef as ReactComponent };